import { PropertyAmenitiesProps, IconName } from "@greystar/ui";
import { getDictionaryEntry } from "./dictionary";
import { useI18n } from "next-localization";

type HighlightKeys = keyof NonNullable<PropertyAmenitiesProps["highlights"]>;

interface HighlightMapping {
  icon: IconName;
  text: string;
}

// Create a function that returns the mapping
export const GetHighlightsMapping = () => {
  const { t } = useI18n();

  return {
    airCon: {
      icon: "Ac",
      text: getDictionaryEntry(
        t("property-highlight-aircon"),
        "Air Conditioning",
      ),
    },
    dishwasher: {
      icon: "Dishwasher",
      text: getDictionaryEntry(
        t("property-highlight-dishwasher"),
        "Dishwasher",
      ),
    },
    eco: {
      icon: "Nature",
      text: getDictionaryEntry(t("property-highlight-eco"), "Eco Friendly"),
    },
    fitness: {
      icon: "FitnessCentre",
      text: getDictionaryEntry(
        t("property-highlight-fitness"),
        "Fitness Center",
      ),
    },
    garages: {
      icon: "CoveredGarageParking",
      text: getDictionaryEntry(t("property-highlight-garages"), "Garage"),
    },
    limitedAccess: {
      icon: "ControlledAccess",
      text: getDictionaryEntry(
        t("property-highlight-limitedaccess"),
        "Limited Access",
      ),
    },
    patioBalcony: {
      icon: "BalconyPatio",
      text: getDictionaryEntry(
        t("property-highlight-patiobalcony"),
        "Patio/Balcony",
      ),
    },
    pets: {
      icon: "PetFriendly",
      text: getDictionaryEntry(t("property-highlight-pets"), "Pet Friendly"),
    },
    playground: {
      icon: "Playground",
      text: getDictionaryEntry(
        t("property-highlight-playground"),
        "Playground",
      ),
    },
    pools: {
      icon: "SwimmingPool",
      text: getDictionaryEntry(t("property-highlight-pools"), "Pool"),
    },
    pool: {
      icon: "SwimmingPool",
      text: getDictionaryEntry(t("property-highlight-pools"), "Pool"),
    },
    smokeFree: {
      icon: "SmokeFree",
      text: getDictionaryEntry(t("property-highlight-smokefree"), "Smoke Free"),
    },
    walkInClosets: {
      icon: "StorageSpace",
      text: getDictionaryEntry(
        t("property-highlight-walkInclosets"),
        "Walk-in Closets",
      ),
    },
    washerDryer: {
      icon: "WasherDryer",
      text: getDictionaryEntry(
        t("property-highlight-washerdryer"),
        "Washer/Dryer",
      ),
    },
  } as Record<HighlightKeys, HighlightMapping>;
};

export const GetHighlightsMappingStatic = () => {
  return {
    airCon: {
      icon: "Ac",
      text: "Air Conditioning",
    },
    dishwasher: {
      icon: "Dishwasher",
      text: "Dishwasher",
    },
    eco: {
      icon: "Nature",
      text: "Eco Friendly",
    },
    fitness: {
      icon: "FitnessCentre",
      text: "Fitness Center",
    },
    garages: {
      icon: "CoveredGarageParking",
      text: "Garage",
    },
    limitedAccess: {
      icon: "ControlledAccess",
      text: "Limited Access",
    },
    patioBalcony: {
      icon: "BalconyPatio",
      text: "Patio/Balcony",
    },
    pets: {
      icon: "PetFriendly",
      text: "Pet Friendly",
    },
    playground: {
      icon: "Playground",
      text: "Playground",
    },
    pool: {
      icon: "SwimmingPool",
      text: "Pool",
    },
    pools: {
      icon: "SwimmingPool",
      text: "Pool",
    },
    smokeFree: {
      icon: "SmokeFree",
      text: "Smoke Free",
    },
    walkInClosets: {
      icon: "StorageSpace",
      text: "Walk-in Closets",
    },
    washerDryer: {
      icon: "WasherDryer",
      text: "Washer/Dryer",
    },
  } as Record<HighlightKeys, HighlightMapping>;
};
